import MarkAttendanceCourseView from './component';
import { isMarkable } from 'data/SessionPlans/accessors';
import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';

export default ({ getState }) => ({
  path: 'course(/:mode)',
  view: 'course',
  component: MarkAttendanceCourseView,
  sessionNav: {
    noUnitSessionNavigation: true,
  },
  canAccess: (props) => {
    const state = getState();
    if (! PrivilegeChecker.hasPrivilege(state, Privileges.MarkAttendance.ViewCourseView)) {
      return false;
    }

    if (! MarkAttendanceCourseView.isInMarkingRoute(props)) {
      return true;
    }

    return PrivilegeChecker.hasPrivilege(state, Privileges.MarkAttendance.MarkCourseView);
  },
  actionButtons: {
    default: {
      Mark: {
        isPrimary: true,
        route: './edit',
        visibleWhen: ({ params: { groupId, sessionPlanId } }) =>
            PrivilegeChecker.hasPrivilege(getState(), Privileges.MarkAttendance.MarkCourseView) &&
              isMarkable(getState(), groupId, sessionPlanId),
      },
      Export: {
        isPrimary: false,
        route: './export',
        visibleWhen: () =>
            PrivilegeChecker.hasPrivilege(getState(), Privileges.MarkAttendance.ViewCourseView),
      },
    },
    edit: {
      Exit: {
        route: {
          mode: '',
        },
      },
    },
  },
  history: (props) => {
    const { params, buildRoute } = props;
    const attendanceHistoryPath = '/group/:groupId/attendance/history';
    const link = buildRoute(attendanceHistoryPath, params);
    return { link };
  },
});



// WEBPACK FOOTER //
// ./containers/Group/Attendance/MarkAttendance/MarkAttendanceCourseView/routes.js